module.exports = __webpack_public_path__ + "img/logo dokter.bb829006.svg";